(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function closeAll(overlay) {
    overlay.querySelectorAll('[data-looty-modal]').forEach(function (modal) {
      modal.classList.remove('is-active');
    });
    overlay.classList.remove('is-active');
    document.body.classList.remove('looty-modal-open');
    window.setTimeout(function () {
      if (!overlay.classList.contains('is-active')) {
        overlay.setAttribute('hidden', '');
        overlay.querySelectorAll('[data-looty-modal]').forEach(function (modal) {
          modal.setAttribute('hidden', '');
        });
      }
    }, 250);
  }

  function openModal(overlay, key) {
    overlay.removeAttribute('hidden');
    overlay.querySelectorAll('[data-looty-modal]').forEach(function (modal) {
      if (modal.getAttribute('data-looty-modal') === key) {
        modal.removeAttribute('hidden');
      } else {
        modal.setAttribute('hidden', '');
      }
    });
    requestAnimationFrame(function () {
      overlay.classList.add('is-active');
      var target = overlay.querySelector('[data-looty-modal="' + key + '"]');
      if (target) target.classList.add('is-active');
    });
    document.body.classList.add('looty-modal-open');
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-looty-modal-open]');
    if (openTrigger) {
      var footer = openTrigger.closest('.looty-footer');
      var overlay = footer && footer.querySelector('[data-looty-modal-overlay]');
      if (overlay) {
        openModal(overlay, openTrigger.getAttribute('data-looty-modal-open'));
      }
      return;
    }

    var closeTrigger = event.target.closest('[data-looty-modal-close]');
    if (closeTrigger) {
      var overlayToClose = closeTrigger.closest('[data-looty-modal-overlay]');
      if (overlayToClose) closeAll(overlayToClose);
      return;
    }

    if (event.target.matches('[data-looty-modal-overlay]')) {
      closeAll(event.target);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-looty-modal-overlay].is-active').forEach(closeAll);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
